/**
 * BranchLabel Component - MA-ARCH-164
 * 
 * Renders a label for branching edges in the funnel visualization.
 * Extracted from FunnelVisualization.jsx.
 */

import React from 'react';
import { cn } from '@/lib/utils';
import { parseConditionToLabel } from '../utils/nodeConfig';

/**
 * BranchLabel - Renders a styled label for branch conditions.
 * 
 * @param {Object} props
 * @param {string} props.label - The label text
 * @param {string} props.condition - The condition expression
 * @param {boolean} props.isHighlighted - Whether the edge is highlighted
 */
export function BranchLabel({ label, condition, isHighlighted }) {
  const displayLabel = parseConditionToLabel(label || condition);
  if (!displayLabel) return null;
  
  return (
    <div className={cn(
      'inline-flex items-center px-2.5 py-0.5 rounded-md',
      'border shadow-sm backdrop-blur-sm',
      'text-[9px] font-semibold tracking-wide uppercase whitespace-nowrap',
      'transition-all duration-150',
      isHighlighted 
        ? 'bg-slate-700/90 border-slate-600/60 text-slate-200' 
        : 'bg-slate-800/90 border-slate-700/50 text-slate-300'
    )}>
      {displayLabel}
    </div>
  );
}

export default BranchLabel;
